import Vue from 'vue';
import VueRouter from 'vue-router';

import storyHunter from './storyHunter/storyHunter.vue';
import home from './home/home.vue';
import mnist from './mnist/mnist.vue';
import songWriter from './songWriter/songWriter.vue';
import styleTransfer from './styleTransfer/styleTransfer.vue';
import boardGamer from './boardGamer/boardGamer.vue';
import bookNotes from './bookNotes/bookNotes.vue';
import notebooks from './notebooks/notebooks.vue';
import notebooksList from './notebooks/notebooksList.vue';
import tournaments from './notebooks/tournaments.vue';
import homebidding from './notebooks/homebidding.vue';
import loanExpenses from './notebooks/loanExpenses.vue';
import demography from './notebooks/demography.vue';
import projectList from './projectList.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: home,
    name: 'home',
  },
  {
    path: '/apps',
    component: projectList,
    name: 'apps',
  },
  {
    path: '/storyhunter',
    component: storyHunter,
    name: 'storyHunter',
  },
  {
    path: '/mnist',
    component: mnist,
    name: 'mnist',
  },
  {
    path: '/songWriter',
    component: songWriter,
    name: 'songWriter',
  },
  {
    path: '/styleTransfer',
    component: styleTransfer,
    name: 'styleTransfer',
  },
  {
    path: '/boardGamer',
    component: boardGamer,
    name: 'boardGamer',
  },
  {
    path: '/bookNotes',
    component: bookNotes,
    name: 'bookNotes',
  },
  {
    path: '/notebooks',
    component: notebooks,
    children: [
      {
        path: '',
        component: notebooksList,
        name: 'notebooks',
      },
      {
        path: 'tournaments',
        component: tournaments,
        name: 'tournaments',
      },
      {
        path: 'homebidding',
        component: homebidding,
        name: 'homebidding',
      },
      {
        path: 'loan-expenses',
        component: loanExpenses,
        name: 'loan-expenses',
      },
      {
        path: 'demography',
        component: demography,
        name: 'demography',
      },
    ],
  },
];

export default new VueRouter({
  mode: 'history',
  routes,
});
